export const getAutoplay = (slider) => {
  const attr = 'data-glide-autoplay';
  const autoplay = slider.getAttribute(attr);
  if (autoplay) {
    return parseInt(autoplay, 10);
  }
  return 0;
};

/**
 * iOS Safari still applies vertical page scroll (often with delayed momentum)
 * during Glide horizontal swipes because Glide uses passive touch listeners
 * and touch-action: pan-y. Prevent default only once the gesture is clearly
 * horizontal so intentional vertical page scrolling still works.
 *
 * @param {Element} element Glide root element
 * @returns {Function} cleanup
 */
export const lockVerticalScrollOnHorizontalSwipe = (element) => {
  if (!element) {
    return () => {};
  }

  let startX = 0;
  let startY = 0;
  let isHorizontal = false;
  const threshold = 8;

  const onTouchStart = (e) => {
    if (!e.touches || e.touches.length !== 1) {
      return;
    }
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isHorizontal = false;
  };

  const onTouchMove = (e) => {
    if (!e.touches || e.touches.length !== 1 || !e.cancelable) {
      return;
    }

    const dx = Math.abs(e.touches[0].clientX - startX);
    const dy = Math.abs(e.touches[0].clientY - startY);

    if (!isHorizontal) {
      if (dx < threshold && dy < threshold) {
        return;
      }
      isHorizontal = dx > dy;
    }

    if (isHorizontal) {
      e.preventDefault();
    }
  };

  const onTouchEnd = () => {
    isHorizontal = false;
  };

  element.addEventListener('touchstart', onTouchStart, { passive: true });
  element.addEventListener('touchmove', onTouchMove, { passive: false });
  element.addEventListener('touchend', onTouchEnd, { passive: true });
  element.addEventListener('touchcancel', onTouchEnd, { passive: true });

  return () => {
    element.removeEventListener('touchstart', onTouchStart);
    element.removeEventListener('touchmove', onTouchMove);
    element.removeEventListener('touchend', onTouchEnd);
    element.removeEventListener('touchcancel', onTouchEnd);
  };
};
